import { RoleLevelEnum } from '@common/graphql';

export function roleLevelParser(roleLevel?: RoleLevelEnum): string {
  return roleLevel?.toLowerCase() === 'not_applicable'
    ? 'None'
    : (roleLevel ?? '');
}
